import styled from 'styled-components';

export var VisuallyHidden = styled.div.withConfig({ displayName: "VisuallyHiddenstyle__VisuallyHidden", componentId: "sc-5dx9es-0" })(["clip:rect(1px,1px,1px,1px);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;position:absolute;"]);
//# sourceMappingURL=VisuallyHidden.style.js.map